<!-- eslint-disable -->
<template>
  <transition name="slide-fade">
    <div class="agreement-page" v-show="show">
      <div class="title">
        <van-icon class="close-icon" name="cross" @touchend="show = false" />
        <span class="title-content">{{ title }}</span>
      </div>
      <div class="agreement-iframe">
        <iframe
          v-if="show"
          :src="agreementUrl"
          frameborder="0"
          class="agreement-frame"
        ></iframe>
      </div>
    </div>
  </transition>
</template>

<script>
  import { mapState } from 'vuex'
  import { getAgreementUrl } from './agreementHtml'

  export default {
    name: 'Agreement',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: '服务协议',
      },
    },
    data() {
      return {
        show: false,
        agreementUrl: '',
      }
    },

    watch: {
      show(newValue) {
        this.$emit('input', newValue)
      },
      title: {
        immediate: true,
        handler(newTitle) {
          this.loadAgreement(newTitle)
        },
      },
    },
    computed: {
      ...mapState({
        systemInfo: state => state.system,
      }),
    },
    mounted() {
      this.$watch('value', {
        handler(value) {
          if (value) {
            this.open()
          } else {
            this.close()
          }
        },
        immediate: true,
      })
    },
    methods: {
      loadAgreement(title) {
        this.agreementUrl = getAgreementUrl(title)
      },
      open() {
        this.show = true
      },
      close() {
        this.show = false
      },
    },
  }
</script>

<style lang="less" scoped>
  .agreement-page {
    position: absolute;
    background: #fff;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .title {
      width: 100%;
      background: #fff;
      height: 46px;
      line-height: 46px;
      font-size: 20px;
      text-align: center;
      position: fixed;
      z-index: 10;
      .close-icon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 24px;
      }
    }
    .agreement-iframe {
      flex: 1;
      margin-top: 46px;
      width: 100%;
      overflow: hidden;
      .agreement-frame {
        width: 100%;
        height: 100%;
        border: none;
        display: block;
      }
    }
  }

  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.3s ease;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateY(100%);
  }
</style>
